export function VusionLiveLogo({ className }: { className?: string }) {
  return (
    <svg
      width="112"
      height="40"
      viewBox="0 0 112 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_3572_25924)">
        <path
          d="M50.4603 22.2462V18.2051H52.3825V22.1099C52.3825 23.1391 52.8365 23.7748 53.7447 23.7899C54.7133 23.8051 55.1371 23.1694 55.1371 22.1099V18.2051H57.0592V22.2613C57.0592 24.0775 55.7122 25.5002 53.7447 25.4851C51.6409 25.4699 50.4603 24.1229 50.4603 22.2462Z"
          fill="#0D2126"
        />
        <path
          d="M58.0582 23.1857H59.7534C59.8442 23.7306 60.4107 23.9879 60.9404 23.9879C61.4701 23.9879 61.8701 23.7306 61.8701 23.3825C61.8701 22.2322 58.2377 22.9435 58.2377 20.1889C58.2377 19.0084 59.2215 18.0549 60.8258 18.0549C62.3847 18.0398 63.4442 18.8722 63.5501 20.2646H61.855C61.7793 19.8408 61.3944 19.5533 60.8799 19.5533C60.3653 19.5533 60.0107 19.8257 60.0107 20.1889C60.0107 21.2938 63.6885 20.6581 63.6885 23.3825C63.6885 24.6538 62.4474 25.4862 60.9944 25.4862C59.3447 25.4862 58.1642 24.5327 58.0582 23.1857Z"
          fill="#0D2126"
        />
        <path
          d="M67.9265 21.7647C67.9265 19.661 69.5157 18.0566 71.7254 18.0566C73.9352 18.0566 75.5243 19.661 75.5243 21.7647C75.5243 23.8685 73.9352 25.488 71.7254 25.488C69.5157 25.488 67.9265 23.8685 67.9265 21.7647ZM73.6325 21.7647C73.6325 20.5691 72.8303 19.7215 71.7254 19.7215C70.6206 19.7215 69.8184 20.5691 69.8184 21.7647C69.8184 22.9604 70.6206 23.808 71.7254 23.808C72.8303 23.808 73.6325 22.9756 73.6325 21.7647Z"
          fill="#0D2126"
        />
        <path
          d="M76.4779 25.3196V21.2785C76.4779 19.4017 77.6736 18.0547 79.8076 18.0547C81.9417 18.0547 83.1222 19.4017 83.1222 21.2785V25.3196H81.2152V21.4298C81.2152 20.3855 80.746 19.7347 79.8076 19.7347C78.8693 19.7347 78.4001 20.3855 78.4001 21.4298V25.3196H76.4779Z"
          fill="#0D2126"
        />
        <path
          d="M50.4453 14.9961L47.4853 25.3161H45.321L48.281 14.9961H50.4453Z"
          fill="#0D2126"
        />
        <path
          d="M43.1049 25.3161L40.1449 14.9961H42.3092L45.2671 25.3161H43.1049Z"
          fill="#0D2126"
        />
        <path
          d="M64.6422 15.9071C64.6422 15.2563 65.1871 14.7266 65.853 14.7266C66.519 14.7266 67.0487 15.2563 67.0487 15.9071C67.0487 16.5579 66.5038 17.0725 65.853 17.0725C65.2022 17.0725 64.6422 16.5579 64.6422 15.9071ZM64.8995 25.319V18.2076H66.8065V25.319H64.8995Z"
          fill="#0D2126"
        />
        <path
          d="M86.127 24.0176H90.8643V25.3192H84.7043V15.0273H86.127V24.0176Z"
          fill="#0D2126"
        />
        <path
          d="M91.7725 15.9784C91.7725 15.4638 92.1811 15.0703 92.6806 15.0703C93.18 15.0703 93.5887 15.4638 93.5887 15.9784C93.5887 16.493 93.18 16.8714 92.6806 16.8714C92.1811 16.8714 91.7725 16.4779 91.7725 15.9784ZM91.9843 25.3168V18.2336H93.3768V25.3168H91.9843Z"
          fill="#0D2126"
        />
        <path
          d="M97.4028 25.3176L94.6179 18.2344H96.1466L97.7509 22.6841C97.8568 22.9717 97.9628 23.3046 98.0233 23.5619H98.0536C98.1141 23.3046 98.2201 22.9717 98.326 22.6841L99.9304 18.2344H101.474L98.6893 25.3176H97.4028Z"
          fill="#0D2126"
        />
        <path
          d="M108.906 22.3199H103.411C103.608 23.4701 104.456 24.1966 105.546 24.1966C106.438 24.1966 107.029 23.8485 107.331 23.1977H108.754C108.33 24.5447 107.104 25.468 105.546 25.468C103.487 25.468 101.974 23.9696 101.974 21.775C101.974 19.5804 103.457 18.082 105.546 18.082C107.407 18.082 108.936 19.6712 108.936 21.775C108.936 21.9869 108.936 22.108 108.906 22.3199ZM103.427 21.1696H107.498C107.407 20.2009 106.62 19.3534 105.546 19.3534C104.471 19.3534 103.638 20.0647 103.427 21.1696Z"
          fill="#0D2126"
        />
        <mask
          id="mask0_3572_25924"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="2"
          y="3"
          width="35"
          height="34"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.2978 3.85486C16.4376 2.32126 12.8756 3.39675 11.342 6.25701L9.80637 9.12111H8.9077V10.7972L3.64118 20.6196C2.10758 23.4799 3.18306 27.0418 6.04333 28.5754L8.9077 30.1112V31.3049H11.134L20.4059 36.2763C23.2662 37.8099 26.8281 36.7344 28.3617 33.8741L29.7393 31.3049H31.0915V28.783L36.0626 19.5115C37.5962 16.6512 36.5207 13.0893 33.6604 11.5557L31.0915 10.1783V9.12111H29.1197L19.2978 3.85486ZM29.1197 9.12111H9.80637H8.9077V10.7972V30.1112V31.3049H11.134H29.7393H31.0915V28.783V10.1783V9.12111H29.1197Z"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_3572_25924)">
          <g filter="url(#filter0_f_3572_25924)">
            <path
              d="M45.7972 19.521C49.0789 31.7685 35.4979 39.9938 27.6279 42.1026C19.7578 44.2114 14.0286 35.1955 10.7469 22.948C7.46518 10.7006 11.6238 8.79563 19.4938 6.68686C27.3639 4.57809 42.5155 7.27355 45.7972 19.521Z"
              fill="#FF61D1"
            />
          </g>
          <g filter="url(#filter1_f_3572_25924)">
            <path
              d="M9.96554 18.5436C13.176 23.5567 18.3621 33.5562 14.4714 36.0479C10.5807 38.5395 0.264956 34.0713 -2.94548 29.0582C-6.15591 24.045 -5.30416 17.7185 -1.41344 15.2269C2.47728 12.7352 6.75511 13.5304 9.96554 18.5436Z"
              fill="#358700"
            />
          </g>
          <g filter="url(#filter2_f_3572_25924)">
            <path
              d="M11.3751 18.4499C18.0509 25.7252 27.2043 42.9983 24.1128 45.8351C21.0213 48.6718 5.82991 44.1685 -0.845834 36.8932C-7.52158 29.6178 -5.48746 23.4526 -2.39596 20.6159C0.695545 17.7791 4.69939 11.1745 11.3751 18.4499Z"
              fill="#FEB000"
            />
          </g>
          <g filter="url(#filter3_f_3572_25924)">
            <path
              d="M33.014 45.459L10.2489 23.7009L41.85 15.2334L33.014 45.459Z"
              fill="#FF3E24"
            />
          </g>
          <g filter="url(#filter4_f_3572_25924)">
            <path
              d="M36.528 -9.89387C47.254 0.964625 44.6225 6.742 37.6021 13.6768C30.5816 20.6116 25.2898 19.5021 14.5638 8.64361C3.83783 -2.21488 -2.78815 -9.4883 4.2323 -16.4231C11.2528 -23.3579 25.802 -20.7524 36.528 -9.89387Z"
              fill="#0188FB"
            />
          </g>
          <g filter="url(#filter5_f_3572_25924)">
            <ellipse
              cx="8.82667"
              cy="5.28018"
              rx="7.59565"
              ry="9.23032"
              transform="rotate(-8.44621 8.82667 5.28018)"
              fill="#26DEFF"
            />
          </g>
        </g>
        <path
          d="M27.0986 13.1014H24.1163L20.0376 27.3303H23.0198L27.0986 13.1014ZM28.9014 7.13477H11.0974C8.78877 7.13477 6.91833 9.0052 6.91833 11.3138V29.1179C6.91833 31.4265 8.78877 33.2969 11.0974 33.2969H28.9014C31.2101 33.2969 33.0805 31.4265 33.0805 29.1179V11.3138C33.0805 9.0052 31.2101 7.13477 28.9014 7.13477ZM31.0902 31.3066H8.90867V9.1251H31.0902V31.3066ZM19.9634 27.3303L15.8847 13.1014H12.9024L16.9812 27.3303H19.9634Z"
          fill="#0D2126"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_3572_25924"
          x="-1.63598"
          y="-5.21838"
          width="59.1888"
          height="58.8821"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="5.62677" result="effect1_foregroundBlur_3572_25924" />
        </filter>
        <filter
          id="filter1_f_3572_25924"
          x="-12.9413"
          y="5.83298"
          width="36.8262"
          height="38.9512"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="4.01222" result="effect1_foregroundBlur_3572_25924" />
        </filter>
        <filter
          id="filter2_f_3572_25924"
          x="-16.7807"
          y="3.65361"
          width="53.0073"
          height="54.5346"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="5.74741" result="effect1_foregroundBlur_3572_25924" />
        </filter>
        <filter
          id="filter3_f_3572_25924"
          x="2.8107"
          y="7.79428"
          width="46.4775"
          height="45.1028"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="3.71907" result="effect1_foregroundBlur_3572_25924" />
        </filter>
        <filter
          id="filter4_f_3572_25924"
          x="-6.39859"
          y="-28.0003"
          width="57.864"
          height="53.7662"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="3.86635" result="effect1_foregroundBlur_3572_25924" />
        </filter>
        <filter
          id="filter5_f_3572_25924"
          x="-6.54196"
          y="-11.6507"
          width="30.7372"
          height="33.8619"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="3.86635" result="effect1_foregroundBlur_3572_25924" />
        </filter>
        <clipPath id="clip0_3572_25924">
          <rect width="112" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
